import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Header.css'
import logo  from '../../Images/logo.jpeg'

const Header = () => {
    return (
        <div>
            <Navbar className="navbar-color" expand="lg">
                <Container fluid>
                    <Navbar.Brand to="home"> <Link to='/'><img className="website-logo " src={logo} alt="" /></Link> </Navbar.Brand>
                    <Navbar.Toggle className="upper" aria-controls="navbarScroll" />
                    <Navbar.Collapse className="upper2" id="navbarScroll">
                        <Nav
                            className="ms-auto my-2 my-lg-0"
                            navbarScroll
                        >
                            <Link className='navItem fw-bolder m-2 ' to="/how-it-works">How it works</Link>
                            <Link className='navItem fw-bolder  m-2 ' to="/about-us">About Us</Link>
                            <Link className='navItem fw-bolder m-2 ' to="/help-center">Help center</Link>
                            <Link className=' mx-2 applyToFinance' to="/apply-to-finance">Apply to finance</Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
};

export default Header;